// extracted by mini-css-extract-plugin
module.exports = {"underlinedLink":"UnderlinedLink-module--underlined-link--3C4o5"};